import { render, staticRenderFns } from "./BookingFormExtras.vue?vue&type=template&id=fb2850c2"
import script from "./BookingFormExtras.vue?vue&type=script&lang=js"
export * from "./BookingFormExtras.vue?vue&type=script&lang=js"
import style0 from "./BookingFormExtras.vue?vue&type=style&index=0&id=fb2850c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports